import { Button, message, Modal, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { uploadImg } from '../../api/api'
import request from '../../utils/request'
import { upload } from '@testing-library/user-event/dist/upload'
import { getBase64 } from '../../utils/getbase64'
import handleFileInUploading from '../../utils/cos'

const UploadlistTypePicture = (props) => {
  const image = props.image
  const imageName = props.imageName
  // console.log(image);
  const [fileList, setFileList] = useState(
    image === ''
      ? []
      : [
          {
            uid: '-1',
            name: `${imageName}`,
            status: 'done',
            url: image,
          },
        ]
  )
  const [thumbUrl, setThumbUrl] = useState()
  //向父组件传值
  const deliverUrl = props.deliverUrl

  //图片预览
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [isRemove, setIsRemove] = useState(false)
  const myUpload = (file) => {
    //转化为formData格式
    // console.log(file)
    // let formData = new FormData()
    // formData.append('file', file.file)
    // // console.log(formData)

    // uploadImg(formData).then((res) => {
    //   // console.log(res.data.data.thumbnail)
    //   setThumbUrl(res.data.data.thumbnail)
    //   setIsRemove(false)
    //   deliverUrl(res.data.data.thumbnail)
    // })
    const afterUpload = (url) => {
      setIsRemove(false)
      const image ='https://' + url.replace('cos.accelerate', 'cos-website.ap-shanghai')
      setFileList([
        {
          ...file,
          name: `${imageName}`,
          url: image,
          status: 'done',
        },
      ])
      deliverUrl(image)
      if ((url ?? false) && url !== '') {
        message.success('图片上传成功！')
      }
    }
    handleFileInUploading(file.file, afterUpload)
  }

  const handleChange = ({ file, fileList }) => {
    console.log('handleCHange', file)
    if (file.status === 'uploading') {
      setFileList([
        {
          ...file,
          url: thumbUrl,
          status: 'uploading',
        },
      ])
    }

    if (file.status === 'removed') {
      setFileList([])
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('只能上传JPG或PNG文件!')
      return false
    }
    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      message.error('图片大小需小于100MB!')
      return false
    }
    console.log(file.type, 'test')
    return isJpgOrPng && isLt100M
  }

  const handlePreview = async (file) => {
    // console.log(file.url, file.preview)
    if ((!file.url && !file.preview) ?? true) {
      file.preview = await getBase64(file.originFileObj)
    }
    // console.log('smyhvae handlePreview:' + JSON.stringify(file))
    setPreviewImage(file.url || file.preview)
    setPreviewOpen(true)
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    )
  }

  const handleCancel = () => setPreviewOpen(false)
  return (
    // <Upload name="logo" customRequest={myUpload} listType="picture">
    //   <Button icon={<UploadOutlined />}>上传图片</Button>
    // </Upload>
    <>
      <Upload
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={myUpload}
        fileList={fileList}
        onPreview={handlePreview}
        listType="picture"
        // onRemove={handleRemove}
      >
        {fileList.length >= 1 ? null : (
          <Button icon={<UploadOutlined />}>上传图片</Button>
        )}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </>
  )
}

export default UploadlistTypePicture
